import { css } from 'config/emotionCss';

const LARGE_MEDIA_QUERY = '@media screen and (max-width: 768px), (max-height: 800px)';

export const largeModalStyle = css`
  width: calc(100% - 40px) !important;
  max-width: 940px;
  min-height: 700px;
  justify-self: center;

  ${LARGE_MEDIA_QUERY} {
    min-height: auto;
  }
`;

export const largeContainerStyle = css`
  min-height: 700px;

  ${LARGE_MEDIA_QUERY} {
    min-height: auto;
  }
`;

export const largeBodyStyle = css`
  min-height: calc(700px - 142px);

  ${LARGE_MEDIA_QUERY} {
    min-height: auto;
  }
`;

export const confirmStyle = css`
  .ant-modal-body {
    .ant-modal-confirm-body-wrapper {
      .ant-modal-confirm-paragraph {
        row-gap: 24px;

        .ant-modal-confirm-title {
          font-size: 22px;
          font-weight: 400;
        }
      }
    }
  }
`;

export const CONFIRM_STYLE_OVERRIDE = {
  container: { width: 520 },
  body: { marginTop: 8 },
};
